export const environment = {
  production: true,
  title: "Medicinae Solutions - Admin",
  name: 'prod',
  api: {
    client_id: "2",
    client_secret: "dhGLOnQlLZhDPJmRaNXXJcAOEcDZnqMtm7VGpc5t",
    base_url: "https://api.iclinicpay.com.br",
    base_api: "https://api.iclinicpay.com.br/api/v1/",
    spreadsheet_importer_api:
      "https://spreadsheet-importer-api.medicinaesolutions.com/prod",
    spreadsheet_importer_ws_api:
      "wss://spreadsheet-importer-ws-api.medicinaesolutions.com/prod"
  },
  assignmentTermRequireGuarantorValue: 200000
};
